import { environment } from '#environments';
import { Dtos } from '#models';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PssrTypeService {
  private _http = inject(HttpClient);
  loadPssrTypes(): Observable<Dtos.PSSRType[]> {
    return this._http.get<Dtos.PSSRType[]>(`${environment.apiUrl}/pssr-types`);
  }
}
